<base-index-page
    [config]="baseIndexPageConfig"
    [service]="qualityManagementService"
    [idKey]="'activityPlanningId'"
    [subSectionSettings]="'deletePlanning'"
></base-index-page>
